var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "modal fade",
      attrs: { id: "myModal", role: "dialog" },
      on: {
        click: function($event) {
          _vm.$emit("close")
        }
      }
    },
    [
      _c(
        "div",
        {
          staticClass: "modal-dialog",
          style: "width:" + _vm.modalWidth + "px",
          on: {
            click: function($event) {
              $event.stopPropagation()
            }
          }
        },
        [
          _c("div", { staticClass: "modal-content" }, [
            _c("div", { staticClass: "modal-header bg-color-info" }, [
              _c(
                "button",
                {
                  staticClass: "close close-btn",
                  attrs: { type: "button", "data-dismiss": "modal" },
                  on: {
                    click: function($event) {
                      _vm.$emit("close")
                    }
                  }
                },
                [_vm._v(" ×")]
              )
            ]),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "modal-body", class: _vm.customBodyClass },
              [
                _vm._v("\n        納品情報を登録しました。 "),
                _c("br"),
                _vm._v(
                  "\n        納品管理番号： " + _vm._s(_vm.deliveryNo) + " "
                ),
                _c("br"),
                _vm._v(" "),
                _c("br"),
                _vm._v(" "),
                _c("p", [
                  _vm._v(
                    "\n          登録した納品情報に従って、STOCKCREW倉庫への発送を行ってください。\n        "
                  )
                ]),
                _vm._v(" "),
                _c("br"),
                _vm._v(" "),
                _vm._m(0),
                _vm._v(" "),
                _c(
                  "button",
                  {
                    staticClass: "btn btn-primary mr-b-10",
                    on: {
                      click: function($event) {
                        _vm.$emit("downloadPackingLabel")
                      }
                    }
                  },
                  [_vm._v("外装ラベル出力")]
                ),
                _vm._v(" "),
                _vm._m(1)
              ]
            ),
            _vm._v(" "),
            _c("div", { staticClass: "modal-footer" }, [
              _c(
                "button",
                {
                  staticClass: "btn btn-warning close-btn",
                  attrs: { type: "button", "data-dismiss": "modal" },
                  on: {
                    click: function($event) {
                      _vm.$emit("close")
                    }
                  }
                },
                [_vm._v("OK")]
              )
            ])
          ])
        ]
      )
    ]
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("p", [
      _c("span", { staticClass: "text-danger" }, [
        _vm._v("発送する際は、外装ラベルを出力して輸送箱へ貼付けしてください。")
      ]),
      _vm._v(" "),
      _c("br"),
      _vm._v(
        "\n          ※外装ラベルは、納品照会画面からも出力いただけます。\n        "
      )
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("p", [
      _c("span", { staticClass: "text-danger" }, [
        _vm._v("※受取金額をご確認ください")
      ]),
      _vm._v(" "),
      _c("br"),
      _vm._v(
        "\n          セルモンに出品している商品の場合、「商品管理 > 商品一覧」 画面にて "
      ),
      _c("br"),
      _vm._v(
        "\n          STOCKCREW倉庫商品の受取金額を確認・変更いただくことが可能です。\n        "
      )
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-7f1de9f5", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7f1de9f5","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/view/warehouseSc/components/ModalAlertAdded.vue
// module id = null
// module chunks = 